import { useTranslation } from 'react-i18next'
import { ChevronDown } from 'lucide-react'
import { cn } from '@/lib/utils'
import type { TeamPerformancePeriod } from '@/types/teamPerformance'

interface Props {
  value: TeamPerformancePeriod
  onChange: (next: TeamPerformancePeriod) => void
  darkMode: boolean
}

// Périodes proposées dans l'ordre d'affichage. Alignement avec Quo
// (rolling 7j / 4 semaines / 12 mois) + nos périodes ancrées calendaires.
const PERIOD_OPTIONS: TeamPerformancePeriod[] = [
  'today',
  'yesterday',
  'last_7_days',
  'cette_semaine',
  'last_4_weeks',
  'ce_mois',
  'ce_trimestre',
  'last_12_months',
  'cette_annee',
]

export function PeriodSelector({ value, onChange, darkMode }: Props) {
  const { t } = useTranslation()

  return (
    <div className="relative inline-block">
      <select
        value={value}
        onChange={(e) => onChange(e.target.value as TeamPerformancePeriod)}
        className={cn(
          'appearance-none rounded-lg border pl-3 pr-9 py-2 text-sm font-medium',
          'focus:outline-none focus:ring-2 focus:ring-indigo-500/40',
          darkMode
            ? 'border-slate-700 bg-slate-800 text-slate-200'
            : 'border-slate-200 bg-white text-slate-700',
        )}
      >
        {PERIOD_OPTIONS.map((p) => (
          <option key={p} value={p}>
            {t(`manager.analytics.periods.${p}`)}
          </option>
        ))}
      </select>
      <ChevronDown
        className={cn(
          'pointer-events-none absolute right-2 top-1/2 -translate-y-1/2 h-4 w-4',
          darkMode ? 'text-slate-400' : 'text-slate-500',
        )}
      />
    </div>
  )
}
